export default "__VITE_ASSET__59413533__"